import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vShow as _vShow, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mall-checkout" }
const _hoisted_2 = { class: "mall-checkout__shell" }
const _hoisted_3 = { class: "mall-checkout__head" }
const _hoisted_4 = {
  key: 0,
  class: "mall-checkout__steps"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = {
  key: 1,
  class: "mall-checkout__empty"
}
const _hoisted_10 = { class: "mall-checkout__main" }
const _hoisted_11 = { class: "mall-checkout__card" }
const _hoisted_12 = { class: "mall-checkout__items" }
const _hoisted_13 = { class: "mall-checkout__item-thumb" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "mall-checkout__item-body" }
const _hoisted_16 = {
  key: 0,
  class: "mall-checkout__item-option"
}
const _hoisted_17 = { class: "mall-checkout__item-price" }
const _hoisted_18 = { class: "mall-checkout__card" }
const _hoisted_19 = { class: "mall-checkout__card-head" }
const _hoisted_20 = { class: "mall-checkout__card-actions" }
const _hoisted_21 = {
  key: 0,
  class: "mall-checkout__addr-chips",
  "aria-label": "배송지 바로선택"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "mall-checkout__fields" }
const _hoisted_24 = { class: "is-full" }
const _hoisted_25 = { class: "mall-checkout__zip-row" }
const _hoisted_26 = ["value"]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "is-full mall-checkout__check" }
const _hoisted_30 = { class: "is-full mall-checkout__check" }
const _hoisted_31 = {
  key: 0,
  class: "is-full"
}
const _hoisted_32 = { class: "is-full" }
const _hoisted_33 = { class: "is-full" }
const _hoisted_34 = { class: "mall-checkout__memo-presets" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "is-full mall-checkout__check" }
const _hoisted_37 = { class: "mall-checkout__card" }
const _hoisted_38 = { class: "mall-checkout__toss" }
const _hoisted_39 = { class: "mall-checkout__pay-amount" }
const _hoisted_40 = {
  key: 0,
  class: "mall-checkout__pay-guide"
}
const _hoisted_41 = {
  key: 0,
  class: "mall-checkout__pay-guide"
}
const _hoisted_42 = {
  key: 1,
  class: "mall-checkout__pay-test"
}
const _hoisted_43 = { class: "mall-checkout__summary" }
const _hoisted_44 = { class: "mall-checkout__cta" }
const _hoisted_45 = { class: "mall-checkout__payable" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  key: 1,
  class: "mall-checkout__error"
}

import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import {
  clearBuyNowKeys,
  getBuyNowKeys,
  isBuyNowCheckoutQuery,
} from '@/composables/useBuyNowCheckout'
import AppIcon from '@/components/common/AppIcon.vue'
import { useCart } from '@/composables/useCart'
import { useCartSelection } from '@/composables/useCartSelection'
import { useDaumPostcode } from '@/composables/useDaumPostcode'
import { useMemberAuth } from '@/composables/useMemberAuth'
import { MALL_SHIPPING_PATH } from '@/constants/mall'
import { formatPrice } from '@/constants/mallProducts'
import {
  createMallOrder,
  fetchMyOrders,
  fetchTossAccess,
  type MallOrder,
} from '@/api/mallOrder'
import {
  createShippingAddress,
  fetchShippingBook,
  saveShippingMemo,
  updateShippingAddress,
  type MallShippingAddress,
} from '@/api/mallShipping'
import { updateMemberContact } from '@/api/member'
import { useTossPayment } from '@/composables/useTossPayment'
import { confirmAction } from '@/utils/confirmAction'
import { formatShippingFeeAmount, toShippingLine } from '@/utils/mallShipping'
import { isEmailValid, isPhoneValid } from '@/utils/formValidation'
import { calcOrderShippingFromLines } from '@/utils/mallSell'

const ORG_ADDRESS_ID = 'org'
const NEW_ADDRESS_ID = 'new'

type AddressOption = {
  id: string
  label: string
  receiver: string
  phone: string
  zipcode: string
  address: string
  addressDetail: string
  isDefault: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MallCheckoutPage',
  setup(__props) {

const MEMO_PRESETS = [
  '배송 전 연락 바랍니다',
  '문 앞에 놓아주세요',
  '경비실에 맡겨주세요',
  '직접 받겠습니다',
] as const

const route = useRoute()
const router = useRouter()
const { lines, reload } = useCart()
const { selectedLines, selectedKeys, clearSelection, selectOnly } = useCartSelection()
const { member, setMember } = useMemberAuth()
const step = ref<'shipping' | 'payment'>('shipping')
const tossEnabled = ref(false)
const {
  ready: tossReady,
  testMode: tossTestMode,
  preparing: tossPreparing,
  mount: mountToss,
  pay: requestTossPay,
} = useTossPayment()
const placedOrder = ref<MallOrder | null>(null)

const buyNowMode = computed(() => isBuyNowCheckoutQuery(route.query))
const buyNowKeys = ref<string[]>(buyNowMode.value ? getBuyNowKeys() : [])

function syncBuyNowSelection() {
  if (!buyNowMode.value) {
    buyNowKeys.value = []
    return
  }
  buyNowKeys.value = getBuyNowKeys()
  if (buyNowKeys.value.length) {
    selectOnly(buyNowKeys.value)
  }
}

/** 바로구매: 상세에서 넘긴 상품만. 장바구니: 고른 줄(없으면 전체). */
const orderLines = computed(() => {
  if (buyNowMode.value) {
    const allow = new Set(buyNowKeys.value)
    return lines.value.filter((line) => allow.has(line.key))
  }
  return selectedKeys.value.length ? selectedLines.value : lines.value
})
const orderSubtotal = computed(() =>
  orderLines.value.reduce((sum, line) => sum + line.lineTotal, 0),
)
const orderListSubtotal = computed(() =>
  orderLines.value.reduce((sum, line) => sum + line.listUnit * line.qty, 0),
)
const orderShipping = computed(() =>
  calcOrderShippingFromLines(
    orderLines.value.map((line) => toShippingLine(line.product, line.qty)),
  ),
)
const orderShippingLabel = computed(() => formatShippingFeeAmount(orderShipping.value))
const orderPayable = computed(() => orderSubtotal.value + orderShipping.value)
const checkoutEmpty = computed(() => !orderLines.value.length && !placedOrder.value)
const { opening: postcodeOpening, searchPostcode } = useDaumPostcode()

const submitting = ref(false)
const errorMessage = ref('')
const pendingOrder = ref<MallOrder | null>(null)
const savedAddresses = ref<MallShippingAddress[]>([])
const selectedAddressId = ref(ORG_ADDRESS_ID)
const saveAddress = ref(false)
const setAsDefault = ref(true)
const saveMemo = ref(false)
const hydrated = ref(false)

const isSavedSelection = computed(() => {
  const id = selectedAddressId.value
  return id !== ORG_ADDRESS_ID && id !== NEW_ADDRESS_ID && /^\d+$/.test(id)
})

const form = reactive({
  label: '',
  receiverName: '',
  receiverPhone: '',
  zipcode: '',
  address: '',
  addressDetail: '',
  memo: '',
  email: '',
})

const orgOption = computed<AddressOption | null>(() => {
  const m = member.value
  if (!m?.address) return null
  return {
    id: ORG_ADDRESS_ID,
    label: '기관 주소',
    receiver: m.bossName || m.orgName || '',
    phone: m.bossPhone || m.orgPhone || '',
    zipcode: m.zipcode || '',
    address: m.address,
    addressDetail: m.addressDetail || '',
    isDefault: savedAddresses.value.length === 0,
  }
})

const addressOptions = computed<AddressOption[]>(() => {
  const saved = savedAddresses.value.map((item) => ({
    id: String(item.idx),
    label: item.label,
    receiver: item.receiver,
    phone: item.phone,
    zipcode: item.zipcode,
    address: item.address,
    addressDetail: item.addressDetail,
    isDefault: item.isDefault,
  }))
  return orgOption.value ? [orgOption.value, ...saved] : saved
})

function applyOption(option: AddressOption) {
  form.receiverName = option.receiver
  form.receiverPhone = option.phone
  form.zipcode = option.zipcode
  form.address = option.address
  form.addressDetail = option.addressDetail
  form.label = option.id === ORG_ADDRESS_ID || option.id === NEW_ADDRESS_ID ? '' : option.label
  saveAddress.value = false
  setAsDefault.value = option.isDefault
}

function selectAddress(id: string) {
  selectedAddressId.value = id
  const option = addressOptions.value.find((item) => item.id === id)
  if (option) applyOption(option)
}

function startNewAddress() {
  selectedAddressId.value = NEW_ADDRESS_ID
  form.label = ''
  form.receiverName = member.value?.bossName || member.value?.orgName || ''
  form.receiverPhone = member.value?.bossPhone || member.value?.orgPhone || ''
  form.zipcode = ''
  form.address = ''
  form.addressDetail = ''
  saveAddress.value = true
  setAsDefault.value = savedAddresses.value.length === 0
}

function fillMemberDefaults(force = false) {
  if (!member.value) return
  if (force || !form.email) form.email = member.value.bossEmail || ''
}

async function loadShippingBook() {
  try {
    const book = await fetchShippingBook()
    savedAddresses.value = book.addresses

    if (!hydrated.value) {
      if (book.pref.lastMemo) form.memo = book.pref.lastMemo

      const defaultSaved = book.addresses.find((item) => item.isDefault) || book.addresses[0]
      if (defaultSaved) {
        selectedAddressId.value = String(defaultSaved.idx)
        applyOption({
          id: String(defaultSaved.idx),
          label: defaultSaved.label,
          receiver: defaultSaved.receiver,
          phone: defaultSaved.phone,
          zipcode: defaultSaved.zipcode,
          address: defaultSaved.address,
          addressDetail: defaultSaved.addressDetail,
          isDefault: defaultSaved.isDefault,
        })
      } else if (orgOption.value) {
        selectedAddressId.value = ORG_ADDRESS_ID
        applyOption(orgOption.value)
      } else {
        startNewAddress()
      }
      hydrated.value = true
    }
  } catch {
    if (!hydrated.value && orgOption.value) {
      selectedAddressId.value = ORG_ADDRESS_ID
      applyOption(orgOption.value)
      hydrated.value = true
    }
  }
}

async function onSearchAddress() {
  try {
    const picked = await searchPostcode()
    if (!picked) return
    form.zipcode = picked.zipcode
    form.address = picked.extra ? `${picked.address} ${picked.extra}` : picked.address
    if (selectedAddressId.value === ORG_ADDRESS_ID) {
      selectedAddressId.value = NEW_ADDRESS_ID
      saveAddress.value = true
    } else if (isSavedSelection.value || selectedAddressId.value === NEW_ADDRESS_ID) {
      saveAddress.value = true
    }
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '주소 검색에 실패했습니다.'
  }
}

function validateShipping() {
  if (!form.receiverName || !form.receiverPhone || !form.address) {
    errorMessage.value = '받는 분, 연락처, 배송지를 모두 입력해 주세요.'
    return false
  }
  if (!isPhoneValid(form.receiverPhone)) {
    errorMessage.value = '휴대폰 번호를 올바르게 입력해 주세요.'
    return false
  }
  if (form.email && !isEmailValid(form.email)) {
    errorMessage.value = '이메일 형식을 확인해 주세요.'
    return false
  }
  return true
}

function validateForm() {
  return validateShipping()
}

async function persistShippingAndContact() {
  const shouldWriteAddress =
    saveAddress.value || (setAsDefault.value && isSavedSelection.value)
  if (shouldWriteAddress) {
    const payload = {
      label: form.label || '기본 배송지',
      receiver: form.receiverName,
      phone: form.receiverPhone,
      zipcode: form.zipcode,
      address: form.address,
      addressDetail: form.addressDetail,
      isDefault: setAsDefault.value || savedAddresses.value.length === 0,
    }
    if (isSavedSelection.value) {
      await updateShippingAddress(Number(selectedAddressId.value), payload)
    } else if (saveAddress.value) {
      const created = await createShippingAddress(payload)
      if (created?.idx) {
        selectedAddressId.value = String(created.idx)
      }
    }
  }

  if (saveMemo.value) {
    await saveShippingMemo(form.memo)
  }

  const updated = await updateMemberContact({
    phone: form.receiverPhone,
    email: form.email,
  })
  if (updated) {
    setMember(updated)
  }
}

const goToPayment = async () => {
  if (checkoutEmpty.value || submitting.value) return
  errorMessage.value = ''
  if (!validateShipping()) return

  submitting.value = true
  try {
    await persistShippingAndContact()
    await loadShippingBook()
    step.value = 'payment'
    window.scrollTo({ top: 0, behavior: 'smooth' })
    if (tossEnabled.value) {
      await nextTick()
      await ensureTossWidget()
    }
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '배송지를 저장하지 못했습니다.'
  } finally {
    submitting.value = false
  }
}

async function ensureTossWidget() {
  if (tossReady.value) return
  await mountToss(
    { methods: '#toss-payment-method', agreement: '#toss-agreement' },
    orderPayable.value,
  )
}

function orderNameOfLines() {
  const first = orderLines.value[0]?.product.name || '함우리몰 상품'
  const extra = orderLines.value.length - 1
  return extra > 0 ? `${first} 외 ${extra}건` : first
}

const onSubmit = async () => {
  if (step.value !== 'payment') return
  if (checkoutEmpty.value || submitting.value) return
  if (!tossEnabled.value) {
    errorMessage.value = '결제창을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.'
    return
  }
  errorMessage.value = ''
  if (!validateForm()) return

  if (orderLines.value.some((line) => line.soldOut || line.stockShort)) {
    errorMessage.value = '품절·재고 부족 상품이 포함되어 있습니다. 장바구니에서 확인해 주세요.'
    return
  }

  if (
    !(await confirmAction(`${formatPrice(orderPayable.value)}원을 결제할까요?`, {
      title: '결제 확인',
      confirmLabel: '결제하기',
      tone: 'primary',
    }))
  ) {
    return
  }

  submitting.value = true
  errorMessage.value = ''
  let createdOrder: { code: string } | null = null

  try {
    const { order } = await createMallOrder({
      receiver: form.receiverName,
      phone: form.receiverPhone,
      email: form.email,
      zipcode: form.zipcode,
      address: form.address,
      addressDetail: form.addressDetail,
      memo: form.memo,
      payMethod: 'TOSS',
      shippingFee: orderShipping.value,
      items: orderLines.value.map((line) => ({
        productId: line.productId,
        qty: line.qty,
        optionName: line.optionName,
        optionExtra: line.optionExtra,
        name: line.product.name,
        price: line.unitPrice,
        image: line.product.image,
        unit: line.product.unit,
      })),
    })

    /* 서버가 주문분만 카트에서 제거한다. 화면 상태만 맞춘다. */
    createdOrder = order
    const orderName = orderNameOfLines().slice(0, 100)
    placedOrder.value = order
    clearBuyNowKeys()
    clearSelection()
    await reload()

    await ensureTossWidget()
    await requestTossPay({
      orderId: order.code,
      orderName,
      amount: order.totalAmount,
      customerName: form.receiverName,
      customerEmail: form.email,
    })
  } catch (error) {
    if (createdOrder) {
      await router.replace({
        path: `/mall/orders/${createdOrder.code}`,
        query: { pay: 'closed' },
      })
      return
    }
    errorMessage.value = error instanceof Error ? error.message : '주문에 실패했습니다.'
  } finally {
    submitting.value = false
  }
}

watch(member, async () => {
  fillMemberDefaults(false)
  if (!hydrated.value) await loadShippingBook()
})

watch(
  () => [route.query.mode, lines.value.map((line) => line.key).join('|')] as const,
  () => {
    syncBuyNowSelection()
  },
  { immediate: true },
)

onMounted(async () => {
  syncBuyNowSelection()
  fillMemberDefaults(true)
  try {
    tossEnabled.value = await fetchTossAccess()
  } catch {
    tossEnabled.value = false
  }
  try {
    const orders = await fetchMyOrders()
    pendingOrder.value =
      orders.find((order) => order.status === 'PENDING' && !order.payNotifiedAt) ??
      orders.find((order) => order.status === 'PENDING') ??
      null
  } catch {
    pendingOrder.value = null
  }
  await loadShippingBook()
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _cache[11] || (_cache[11] = _createElementVNode("h1", null, "주문하기", -1)),
        (!checkoutEmpty.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
              (step.value === 'shipping')
                ? (_openBlock(), _createElementBlock("strong", _hoisted_5, "1 배송지"))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, "1 배송지")),
              _cache[10] || (_cache[10] = _createElementVNode("i", null, "›", -1)),
              (step.value === 'payment')
                ? (_openBlock(), _createElementBlock("strong", _hoisted_7, "2 결제"))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, "2 결제"))
            ]))
          : _createCommentVNode("", true)
      ]),
      (pendingOrder.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["mall-checkout__pending", { 'is-confirming': Boolean(pendingOrder.value.payNotifiedAt) }])
          }, [
            _createVNode(AppIcon, {
              icon: pendingOrder.value.payNotifiedAt ? 'mdi-check-circle-outline' : 'mdi-alert-circle-outline',
              size: 18
            }, null, 8, ["icon"]),
            _createElementVNode("p", null, [
              (pendingOrder.value.payMethod === 'TOSS')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" 결제를 마치지 않은 주문이 있습니다. ")
                  ], 64))
                : (pendingOrder.value.payNotifiedAt)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" 입금 확인 중인 주문이 있습니다. ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(" 입금 대기 중인 주문이 있습니다. ")
                    ], 64)),
              _createVNode(_component_router_link, {
                to: `/mall/orders/${pendingOrder.value.code}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(pendingOrder.value.code) + " 확인하기 ", 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ], 2))
        : _createCommentVNode("", true),
      (checkoutEmpty.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _cache[13] || (_cache[13] = _createElementVNode("p", null, "주문할 상품이 없습니다.", -1)),
            _createVNode(_component_router_link, { to: "/mall/cart" }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode("장바구니로 이동", -1)
              ]))]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("form", {
            key: 2,
            class: "mall-checkout__layout",
            onSubmit: _withModifiers(onSubmit, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("section", _hoisted_11, [
                _createElementVNode("h2", null, "주문 상품 " + _toDisplayString(orderLines.value.length), 1),
                _createElementVNode("ul", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderLines.value, (line) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: line.key
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("img", {
                          src: line.product.image,
                          alt: line.product.name
                        }, null, 8, _hoisted_14)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("strong", null, _toDisplayString(line.product.name), 1),
                        (line.optionName)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(line.optionName), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_17, [
                          _createElementVNode("b", null, _toDisplayString(line.qty) + "개", 1),
                          _createElementVNode("b", null, _toDisplayString(_unref(formatPrice)(line.lineTotal)) + "원", 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _withDirectives(_createElementVNode("section", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[15] || (_cache[15] = _createElementVNode("h2", null, "배송지", -1)),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_router_link, {
                      to: _unref(MALL_SHIPPING_PATH),
                      class: "mall-checkout__text-btn"
                    }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode("배송지 관리", -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "mall-checkout__text-btn",
                      onClick: startNewAddress
                    }, " 새로 입력 ")
                  ])
                ]),
                (addressOptions.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addressOptions.value, (option) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: `chip-${option.id}`,
                          type: "button",
                          class: _normalizeClass(["mall-checkout__chip", { 'is-active': selectedAddressId.value === option.id }]),
                          onClick: ($event: any) => (selectAddress(option.id))
                        }, _toDisplayString(option.label), 11, _hoisted_22))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", null, [
                    _cache[16] || (_cache[16] = _createElementVNode("span", null, "수령인", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.receiverName) = $event)),
                      required: "",
                      placeholder: "이름"
                    }, null, 512), [
                      [
                        _vModelText,
                        form.receiverName,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[17] || (_cache[17] = _createElementVNode("span", null, "연락처", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.receiverPhone) = $event)),
                      required: "",
                      placeholder: "010-0000-0000"
                    }, null, 512), [
                      [
                        _vModelText,
                        form.receiverPhone,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_24, [
                    _cache[18] || (_cache[18] = _createElementVNode("span", null, "주소", -1)),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("input", {
                        value: form.zipcode,
                        type: "text",
                        placeholder: "우편번호",
                        readonly: "",
                        onClick: onSearchAddress
                      }, null, 8, _hoisted_26),
                      _createElementVNode("button", {
                        type: "button",
                        class: "mall-checkout__ghost",
                        disabled: _unref(postcodeOpening),
                        onClick: onSearchAddress
                      }, " 주소 검색 ", 8, _hoisted_27)
                    ]),
                    _createElementVNode("input", {
                      value: form.address,
                      type: "text",
                      required: "",
                      placeholder: "주소 검색을 눌러 주세요",
                      readonly: "",
                      class: "mall-checkout__addr-input",
                      onClick: onSearchAddress
                    }, null, 8, _hoisted_28),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.addressDetail) = $event)),
                      type: "text",
                      maxlength: "80",
                      placeholder: "상세 주소 (동·호수 등)",
                      class: "mall-checkout__addr-input"
                    }, null, 512), [
                      [
                        _vModelText,
                        form.addressDetail,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_29, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((saveAddress).value = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, saveAddress.value]
                    ]),
                    _createElementVNode("span", null, _toDisplayString(isSavedSelection.value
                      ? '변경한 내용으로 이 배송지를 저장'
                      : '이 배송지를 다음에 쓰기'), 1)
                  ]),
                  _createElementVNode("label", _hoisted_30, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((setAsDefault).value = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, setAsDefault.value]
                    ]),
                    _cache[19] || (_cache[19] = _createElementVNode("span", null, "기본 배송지로 사용", -1))
                  ]),
                  (saveAddress.value)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_31, [
                        _cache[20] || (_cache[20] = _createElementVNode("span", null, "배송지 이름", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.label) = $event)),
                          maxlength: "40",
                          placeholder: "예: 본원 · 분원"
                        }, null, 512), [
                          [
                            _vModelText,
                            form.label,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("label", _hoisted_32, [
                    _cache[21] || (_cache[21] = _createElementVNode("span", null, "이메일 (선택)", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.email) = $event)),
                      type: "email",
                      placeholder: "결제·배송 안내를 받을 이메일"
                    }, null, 512), [
                      [
                        _vModelText,
                        form.email,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _cache[22] || (_cache[22] = _createElementVNode("em", { class: "mall-checkout__field-note" }, "적으면 회원 이메일로 저장하고, 결제부터 메일로 안내합니다.", -1))
                  ]),
                  _cache[25] || (_cache[25] = _createElementVNode("p", { class: "mall-checkout__field-note mall-checkout__field-note--block" }, " 위의 연락처는 회원 휴대폰 번호로 저장됩니다. ", -1)),
                  _createElementVNode("label", _hoisted_33, [
                    _cache[23] || (_cache[23] = _createElementVNode("span", null, "배송 요청", -1)),
                    _createElementVNode("div", _hoisted_34, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(MEMO_PRESETS, (preset) => {
                        return _createElementVNode("button", {
                          key: preset,
                          type: "button",
                          class: _normalizeClass(["mall-checkout__chip", { 'is-active': form.memo === preset }]),
                          onClick: ($event: any) => (form.memo = preset)
                        }, _toDisplayString(preset), 11, _hoisted_35)
                      }), 64))
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.memo) = $event)),
                      maxlength: "255",
                      placeholder: "필요하면 직접 입력"
                    }, null, 512), [
                      [
                        _vModelText,
                        form.memo,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_36, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((saveMemo).value = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, saveMemo.value]
                    ]),
                    _cache[24] || (_cache[24] = _createElementVNode("span", null, "이 요청을 다음 주문 기본값으로 저장", -1))
                  ])
                ])
              ], 512), [
                [_vShow, step.value === 'shipping']
              ]),
              _withDirectives(_createElementVNode("section", _hoisted_37, [
                _cache[30] || (_cache[30] = _createElementVNode("h2", null, "결제", -1)),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _cache[26] || (_cache[26] = _createElementVNode("span", null, "결제할 금액", -1)),
                    _createElementVNode("strong", null, _toDisplayString(_unref(formatPrice)(orderPayable.value)) + "원", 1)
                  ]),
                  (!tossEnabled.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_40, " 결제창을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요. "))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_unref(tossPreparing))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_41, "결제창을 불러오는 중입니다."))
                          : _createCommentVNode("", true),
                        _cache[27] || (_cache[27] = _createElementVNode("div", {
                          id: "toss-payment-method",
                          class: "mall-checkout__toss-frame"
                        }, null, -1)),
                        _cache[28] || (_cache[28] = _createElementVNode("div", {
                          id: "toss-agreement",
                          class: "mall-checkout__toss-frame"
                        }, null, -1)),
                        _cache[29] || (_cache[29] = _createElementVNode("p", { class: "mall-checkout__pay-caution" }, " 카드, 간편결제, 휴대폰결제를 받습니다. 계좌이체·가상계좌를 고르면 그 결제는 취소됩니다. ", -1)),
                        (_unref(tossTestMode))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_42, " 테스트 결제입니다. 승인해도 카드에서 금액이 빠지지 않습니다. "))
                          : _createCommentVNode("", true)
                      ], 64))
                ])
              ], 512), [
                [_vShow, step.value === 'payment']
              ])
            ]),
            _createElementVNode("aside", _hoisted_43, [
              _cache[35] || (_cache[35] = _createElementVNode("h2", null, "결제 금액", -1)),
              _createElementVNode("dl", null, [
                _createElementVNode("div", null, [
                  _cache[31] || (_cache[31] = _createElementVNode("dt", null, "상품금액", -1)),
                  _createElementVNode("dd", null, _toDisplayString(_unref(formatPrice)(orderListSubtotal.value)) + "원", 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[32] || (_cache[32] = _createElementVNode("dt", null, "주문 배송비", -1)),
                  _createElementVNode("dd", null, _toDisplayString(orderShippingLabel.value), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _cache[33] || (_cache[33] = _createElementVNode("span", null, "결제할 금액", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_unref(formatPrice)(orderPayable.value)) + "원", 1)
                ]),
                (step.value === 'shipping')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "mall-checkout__submit",
                      disabled: submitting.value || !orderLines.value.length,
                      onClick: goToPayment
                    }, _toDisplayString(submitting.value ? '저장 중…' : '다음 · 결제하기'), 9, _hoisted_46))
                  : (step.value === 'payment')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "submit",
                        class: "mall-checkout__submit",
                        disabled: submitting.value || !orderLines.value.length || !tossEnabled.value || !_unref(tossReady)
                      }, _toDisplayString(submitting.value
                  ? '주문 접수 중…'
                  : _unref(tossReady)
                    ? `${_unref(formatPrice)(orderPayable.value)}원 결제하기`
                    : '결제창 준비 중…'), 9, _hoisted_47))
                    : _createCommentVNode("", true)
              ]),
              (step.value === 'payment')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "mall-checkout__text-btn",
                    disabled: submitting.value,
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (step.value = 'shipping'))
                  }, " 배송지 다시 보기 ", 8, _hoisted_48))
                : _createCommentVNode("", true),
              (errorMessage.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(errorMessage.value), 1))
                : _createCommentVNode("", true),
              (placedOrder.value && step.value === 'payment')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    class: "mall-checkout__text-btn",
                    to: `/mall/orders/${placedOrder.value.code}`
                  }, {
                    default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                      _createTextVNode(" 주문 상세에서 결제 이어하기 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ])
          ], 32))
    ])
  ]))
}
}

})